//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { mapActions, mapGetters } from 'vuex';
import ErrorDisplay from '../../common/ErrorDisplay.vue';
import Logo from '../../common/svg/Logo';

export default {
  data() {
    return {
      username: '',
      password: '',
      loading: false,
      error: null,
      login_status: null,
      state: '',
    };
  },
  methods: {
    ...mapActions([
      'initialize', 'authenticate',
    ]),
    async login() {
      this.state = 'Signing In...';
      this.loading = true;
      this.login_status = null;
      this.error = null;
      try {
        await this.authenticate({
          email: this.username.trim(),
          password: this.password.trim(),
        });
        this.login_status = 'Successful login';
        this.state = 'Loading Data...';

        await this.initialize();
        this.state = 'Success!';

        if (this.platform() === 'ios') {
          window.webkit.messageHandlers.callbackHandler.postMessage(JSON.stringify({
            type: 'setMemberId',
            memberId: this.loggedInMember.memberId,
            sub: this.loggedInMember.awsCognitoSub,
          }));
        }

        if (this.isCoach) {
          this.$router.replace('/team');
        } else {
          this.$router.replace(this.$route.query.redirect || '/');
        }
      } catch (error) {
        this.handle_login_error(error);
      }
      return true;
    },
    handle_login_error(error) {
      if (error.response && error.response.data) {
        this.error = error.response.data;
      } else {
        this.error = error;
      }
      this.login_status = 'Failed login';
      this.loading = false;
    },
  },
  computed: {
    ...mapGetters([
      'user', 'isCoach', 'loggedInMember',
    ]),
  },
  components: {
    Logo,
    ErrorDisplay,
  },
};
